import { Theme } from "@mui/material";

export const confirmDialogStyle = (theme: Theme) => ({
  title: {
    fontWeight: "bold",
    fontSize: "1rem",
    textAlign: "left",
    px: 2,
    pt: 2,
    color: theme.palette.text.primary,
  },
  content: {
    textAlign: "left",
    fontSize: "0.95rem",
    px: 2,
    py: 1,
    color: theme.palette.text.primary,
  },
  actions: {
    justifyContent: "flex-end",
    px: 2,
    pb: 2,
    gap: 1,
  },
  cancelButton: {
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.grey[800]
          : theme.palette.grey[100],
    },
  },
  confirmButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});
